<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    usernameAvatar: {
      type: String,
      default: '',
    },
    deleteAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedFileName: '',
    };
  },
  watch: {},
  methods: {
    handleImageUpload(event) {
      const [file] = event.target.files;

      if (file) {
        this.selectedFileName = file.name;
      } else {
        this.selectedFileName = '';
      }

      this.$emit('change', {
        file,
        url: file ? URL.createObjectURL(file) : null,
      });
    },
    onAvatarDelete() {
      this.$refs.file.value = null;
      this.selectedFileName = '';
      this.$emit('onAvatarDelete');
    },
    triggerFileInput() {
      this.$refs.file.click();
    },
  },
};
</script>

<template>
  <div>
    <label>
      <span v-if="label">{{ label }}</span>
    </label>
    <woot-thumbnail
      v-if="src"
      size="80px"
      :src="src"
      :username="usernameAvatar"
    />
    <div v-if="src && deleteAvatar" class="avatar-delete-btn">
      <woot-button
        color-scheme="alert"
        variant="hollow"
        size="tiny"
        type="button"
        @click="onAvatarDelete"
      >
        {{ $t('INBOX_MGMT.DELETE.AVATAR_DELETE_BUTTON_TEXT') }}
      </woot-button>
    </div>
    <div class="file-upload-container">
      <input
        id="file"
        ref="file"
        type="file"
        accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
        class="hidden-file-input"
        @change="handleImageUpload"
      />
      <woot-button
        variant="smooth"
        size="small"
        type="button"
        @click="triggerFileInput"
      >
        {{ $t('CONTACT_FORM.FORM.AVATAR.CHOOSE_FILE') }}
      </woot-button>
      <span v-if="selectedFileName" class="file-name">
        {{ selectedFileName }}
      </span>
      <span v-else class="no-file">
        {{ $t('CONTACT_FORM.FORM.AVATAR.NO_FILE') }}
      </span>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.avatar-delete-btn {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-smaller);
}

.file-upload-container {
  margin-top: var(--space-smaller);
  display: flex;
  align-items: center;
  gap: var(--space-small);
}

.hidden-file-input {
  display: none;
}

.file-name {
  font-size: var(--font-size-small);
  color: var(--s-700);
}

.no-file {
  font-size: var(--font-size-small);
  color: var(--s-400);
}
</style>
